function ProgressBar({ customStyles, className = 'relative flex justify-start h-0.5 w-full bg-neutral-200 mt-2' }) {
  return (
    <div className={className}>
      <div
        className="absolute left-0 h-0.5 w-full origin-left bg-neutral-900 transition-transform"
        style={customStyles}
      />
    </div>
  )
}

export default ProgressBar
